import { render } from "./SaveConfirmation.vue?vue&type=template&id=5021fe13&scoped=true"
import script from "./SaveConfirmation.vue?vue&type=script&lang=js"
export * from "./SaveConfirmation.vue?vue&type=script&lang=js"

import "./SaveConfirmation.vue?vue&type=style&index=0&id=5021fe13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5021fe13"]])

export default __exports__